/* PMSTEEL · mouse drag-to-scroll for Dawn sliders (review feedback 07-15).
   Touch already scrolls natively; this adds the same feel for mouse users:
   press and drag anywhere on a carousel to scroll it. A 6px threshold
   distinguishes a drag from a click, and the click that ends a drag is
   suppressed so dragging across a product card never opens it.
   Scroll-snap is paused while dragging (it fights the pointer), then the
   slider glides to the nearest snap point on release. */
(function () {
  var THRESHOLD = 6;

  function enhance(slider) {
    if (slider.dataset.pmDrag) return;
    slider.dataset.pmDrag = '1';
    slider.classList.add('pmsteel-draggable');

    var startX = 0;
    var startScroll = 0;
    var dragging = false;
    var moved = false;

    slider.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      dragging = true;
      moved = false;
      startX = e.clientX;
      startScroll = slider.scrollLeft;
    });

    slider.addEventListener('pointermove', function (e) {
      if (!dragging || e.pointerType !== 'mouse') return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) < THRESHOLD) return;
      if (!moved) {
        moved = true;
        slider.classList.add('pmsteel-dragging');
        try { slider.setPointerCapture(e.pointerId); } catch (err) { /* noop */ }
      }
      slider.scrollLeft = startScroll - dx;
      e.preventDefault();
    });

    function end(e) {
      if (!dragging) return;
      dragging = false;
      if (!moved) return;
      slider.classList.remove('pmsteel-dragging');
      try { slider.releasePointerCapture(e.pointerId); } catch (err) { /* noop */ }
      // swallow the click that follows a drag so cards/links don't activate
      slider.addEventListener('click', function swallow(ev) {
        ev.preventDefault();
        ev.stopPropagation();
        slider.removeEventListener('click', swallow, true);
      }, true);
      // glide to the nearest snap point (snap was off during the drag)
      var item = slider.querySelector('.slider__slide, .grid__item');
      if (item) {
        var w = item.getBoundingClientRect().width;
        var gap = parseFloat(getComputedStyle(slider).columnGap) || 0;
        var unit = w + gap;
        if (unit > 0) {
          slider.scrollTo({ left: Math.round(slider.scrollLeft / unit) * unit, behavior: 'smooth' });
        }
      }
    }
    slider.addEventListener('pointerup', end);
    slider.addEventListener('pointercancel', end);
    // images/links must not start a native drag mid-scroll
    slider.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  function scan(root) {
    (root || document).querySelectorAll('slider-component .slider').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }
  // sections re-render in the editor and on dynamic loads
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
